import { useEffect, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { AiFillPlusCircle } from "react-icons/ai";
import { GameSet as GameSetModel } from "../../../models/gameSet";
import * as GameSetsApi from "../../../network/gameSets_api";
import * as ItemsApi from "../../../network/items_api";
import styles from "../GameSetsPage.module.scss";
import AddEditGameSet from "./AddEditGameSet";
import { useTranslation } from "react-i18next";
import Divider from "../../../components/Decors/Divider/Divider";
import GameSetCard from "./GameSetCard";

const GameSetsLoggedInView = () => {
  const { t } = useTranslation();
  const [gameSets, setGameSets] = useState<GameSetModel[]>([]);
  const [gameSetsLoading, setGameSetsLoading] = useState(true);
  const [showGameSetsLoadingError, setShowGameSetsLoadingError] =
    useState(false);

  const [gameSetToAdd, setGameSetToAdd] = useState(false);
  const [gameSetToEdit, setGameSetToEdit] = useState<GameSetModel | false>(
    false
  );

  useEffect(() => {
    async function loadGameSet() {
      try {
        setShowGameSetsLoadingError(false);
        setGameSetsLoading(true);
        const gameSets = await GameSetsApi.fetchGameSets();
        setGameSets(gameSets);
      } catch (error) {
        console.error(error);
        setShowGameSetsLoadingError(true);
      } finally {
        setGameSetsLoading(false);
      }
    }
    loadGameSet();
  }, []);

  async function deleteGameSet(gameSet: GameSetModel) {
    try {
      await GameSetsApi.deleteGameSet(gameSet._id);
      const items = await ItemsApi.fetchItems(gameSet._id);
      items.forEach(async (element) => {
        await ItemsApi.deleteItem(element._id, gameSet._id);
      });
      setGameSets(
        gameSets.filter(
          (existingGameSet) => existingGameSet._id !== gameSet._id
        )
      );
    } catch (error) {
      console.error(error);
      alert(error);
    }
  }

  const gameSetsGrid = (
    <Row xs={1} sm={2} md={3} xl={4} className={`g-4 ${styles.gameSetGrid}`}>
      <Col>
        <Card
          className={`${styles.gameSet} ${styles.addGameSet} ${"flexCenter"}`}
          onClick={() => setGameSetToAdd(true)}
        >
          <AiFillPlusCircle className="addGameSetIcon" />
        </Card>
      </Col>
      {gameSets.map((gameSet) => (
        <Col key={gameSet._id}>
          <GameSetCard
            gameSet={gameSet}
            className={styles.gameSet}
            onUpdateGameSetClicked={setGameSetToEdit}
            onDeleteGameSetClicked={deleteGameSet}
          />
        </Col>
      ))}
    </Row>
  );

  return (
    <>
      {!(gameSetToEdit || gameSetToAdd) && (
        <div className={styles.gameSetGridContainer}>
          <div className="title-block-container">
            <h1>
              {t('pages.gameSets')}
            </h1>
            <Divider />
          </div>
          {gameSetsLoading && (
            <Spinner className="custom-spinner" animation="border" />
          )}
          {showGameSetsLoadingError && (
            <p>{t('error.refresh')}</p>
          )}
          {!gameSetsLoading && !showGameSetsLoadingError && (
            <Container>{gameSetsGrid}</Container>
          )}
        </div>
      )}
      {gameSetToAdd && (
        <AddEditGameSet
          onDismiss={() => setGameSetToAdd(false)}
          onGameSetSaved={(newGameSet) => {
            setGameSets([...gameSets, newGameSet]);
          }}
        />
      )}
      {gameSetToEdit && (
        <AddEditGameSet
          gameSetToEdit={gameSetToEdit}
          onDismiss={() => setGameSetToEdit(false)}
          onGameSetSaved={(updatedGameSet) => {
            setGameSets(
              gameSets.map((existingGameSet) =>
                existingGameSet._id === updatedGameSet._id
                  ? updatedGameSet
                  : existingGameSet
              )
            );
          }}
        />
      )}
    </>
  );
};

export default GameSetsLoggedInView;
